<template>
  <div>
    <v-form ref="frmProgram" v-model="valid">
        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col>
                        <v-checkbox
                        v-model="blacklist"
                        :label="`Blacklist`"
                        @change="chooseBlacklist"
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-menu
                            ref="startDateMenu"
                            v-model="startDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="startDate"
                                    label="Tanggal Mulai Blacklist"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="startDate"
                                @input="startDateMenu = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="6">
                        <v-menu
                            ref="endDateMenu"
                            v-model="endDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="endDate"
                                    label="Tanggal Selesai Blacklist"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="endDate"
                                @input="endDateMenu = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="text-center">  
                        <v-btn color="primary" @click="submitData()">SUBMIT</v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-form>
    
    
    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

    <!-- Notification -->
    <v-snackbar
        v-model="notification.show"
        :color="notification.color"
        :top="true"
        :right="true"
        :timeout=3000
    >
        {{notification.text}}
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'
const apiUrl = process.env.VUE_APP_ROOT_API
import { rules } from './../../lib/rules'

export default {
  name: 'Blacklist Vendor',
  props: [
    'Id'
  ],
  watch: {
    Id: function(newVal, oldVal) {
      console.log(`oldVal = ${oldVal}, newVal = ${newVal}`)
      this.getVendorData(newVal)
    }
  },
  data: function() {
    return {
      blacklist: false,
      startDate: "",
      endDate: "",
      submitting: false,
      startDateMenu: false,
      endDateMenu: false,
      notification:
      {
        show: false,
        color: "",
        text: ""
      },
      rules: {
        required: rules.required
      },
      valid: true,
    }
  },
  computed: {
    
  },
  mounted: function() {
     this.getVendorData();
  },
  methods: {
    
    getVendorData: async function() {
      this.remarkSubmitted = false;
      
      await axios.get(`${apiUrl}/vendor/${this.Id}`)
      .then((response) => {
        const ven = response.data.data
        this.blacklist = ven.blacklist
        this.startDate = (ven.blacklistTglMulai === null || ven.blacklistTglMulai === '0000-00-00') ? '' : ven.blacklistTglMulai
        this.endDate = (ven.blacklistTglSelesai === null || ven.blacklistTglSelesai === '0000-00-00') ? '' : ven.blacklistTglSelesai
      })
    },
    chooseBlacklist: function(value) {
        console.log('Blacklist is now:', value);
        this.blacklist = value ? 1 : 0;
        if (!value) {
            this.startDate = "";
            this.endDate = "";
        }
    },

    submitData: async function() {
        console.log("Submitting data...");
        console.log("Blacklist:", this.blacklist);
        console.log("Start Date:", this.startDate);
        console.log("End Date:", this.endDate);
        if (!this.$refs.frmProgram.validate())
          return null
        this.submitting = true;
        try {
            const payload = {
                vendorId: this.Id,
                blacklist: this.blacklist,
                blacklistTglMulai: this.startDate,
                blacklistTglSelesai: this.endDate,
            };
            const response = await axios.post(`${apiUrl}/vendor/blacklist/update`, payload);

            if (response.data.success) {
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Data successfully updated!",
                };
            } else {
                this.notification = {
                    show: true,
                    color: "danger",
                    text: "Data failed updated!",
                };
            }
        } catch (error) {
            console.error("Error submitting data:", error);
            this.notification = {
                show: true,
                color: "error",
                text: "Failed to update data. Please try again.",
            };
        } finally {
            this.submitting = false;
        }
        
    },

  }
}
</script>

<style>

</style>